export const progressColors = ['#e2e2e2', '#007aff'];
